import React, { useContext } from 'react';
const AppContext = React.createContext(null);
export const useApp = () => useContext(AppContext);
export const useNavigateToUrl = () => { var _a; return (_a = useApp()) === null || _a === void 0 ? void 0 : _a.navigateToUrl; };
export const useOnAuthSuccess = () => { var _a; return (_a = useApp()) === null || _a === void 0 ? void 0 : _a.onAuthSuccess; };
export const usePublic = () => { var _a; return (_a = useApp()) === null || _a === void 0 ? void 0 : _a.public; };
export default AppContext;
